import { AppRouter } from '@/app/router/AppRouter';

export function App() {
  return <AppRouter />;
}
